
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipper",
      function () {
        return require("private-next-pages/shipper/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipper"])
      });
    }
  